module.exports = __webpack_public_path__ + "img/dtgt.8b376a7d.jpg";